/** Header count for a paginated register. Chip filters stay page-local. */
export function registerHeaderCount(
  apiTotal: number,
  filteredLength: number,
  filterIsAll: boolean
) {
  return filterIsAll ? apiTotal : filteredLength
}

/** Page count for the pager. Prefer the API page count, otherwise derive it. */
export function pageCountFromTotal(
  totalItems: number,
  pageSize: number,
  totalPages?: number
) {
  if (totalPages && totalPages > 0) return totalPages
  if (pageSize <= 0) return 0
  return Math.ceil(totalItems / pageSize)
}
